import React, { Component } from 'react';
import { message } from 'antd';
import AdminCompaniesAddUserView from '../views/AdminCompaniesAddUserView';
import { base, secondaryApp } from '../../base';

class AdminCompaniesAddUserContainer extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(values) {
        const cid = this.props.companyid;
        let errorHappend = false;
        secondaryApp.auth().createUserWithEmailAndPassword(values.email, values.password)
            .catch((error) => {
                errorHappend = true;
                // Handle Errors here.
                const errorCode = error.code;
                const errorMessage = error.message;
                if (errorCode === 'auth/weak-password') {
                    message.error('El password es inseguro, ingrese un password mas seguro con letras y numeros');
                } else {
                    alert(errorMessage);
                }
            })
            .then((authData) => {
                if (!errorHappend) {
                    base.post(`users/${values.username}`, {
                        data:
                            {
                                type: values.rol,
                                lang: 'es',
                                companyid: cid,
                                uid: authData.user.uid,
                            },
                        then(err) {
                            if (!err) {
                                message.success('Se creo el usuario correctamente');
                            }
                        },
                    });
                }
            });
        return this;
    }

    render() {
        return (
            <AdminCompaniesAddUserView
                handleSubmit={this.handleSubmit}
            />
        );
    }
}
export default AdminCompaniesAddUserContainer;



// WEBPACK FOOTER //
// ./src/components/containers/AdminCompaniesAddUserContainer.js